<template>
    <div>
        <div class="page_title gradient_overlay" style="background: url(/assets/images/page_title_bg.jpg);">
            <div class="container">
                <div class="inner">
                    <h1 v-lang.restaurants></h1>
                    <ol class="breadcrumb">
                        <li>
                            <router-link to="/" v-lang.inicio></router-link>
                        </li>
                        <li v-lang.restaurants></li>
                    </ol>
                </div>
            </div>
        </div>

        <div class="container" style="margin-top: 4em;">
            <div class="row">
                <div class="col-md-3 col-md-offset-9">
                    <select v-model="type" name="" id="" class="form-control">
                        <option v-bind:value="'grid'" v-lang.grid></option>
                        <option v-bind:value="'list'" v-lang.list></option>
                        <option v-bind:value="'block'" v-lang.block></option>
                    </select>
                </div>
            </div>
        </div>

        <transition name="fade">
            <block-view :restaurants="restaurants"  v-show="type=='block'"></block-view>
        </transition>

        <transition name="fade">
            <list-view :restaurants="restaurants"  v-show="type=='list'"></list-view>
        </transition>

        <transition name="fade">
            <grid-view :restaurants="restaurants"  v-show="type=='grid'"></grid-view>
        </transition>

    </div>
</template>
<script>
    import {isNull} from 'lodash';
    import BlockView from './Views/BlockView.vue';
    import GridView from './Views/GridView.vue';
    import ListView from './Views/ListView.vue';
    export default
    {
        data : function(){
            return {
                restaurants : [],
                type : 'grid', //list,grid,block
            }
        },
        components : {
            'block-view' : BlockView,
            'grid-view' : GridView,
            'list-view' : ListView,
        },
        created : function()
        {
            let self = this;
            this.unsubscribe  = this.$store.subscribe((mutation,state) => {
                self.$language = self.$store.state.language;
                if( self.$store.getters.config != null )
                {
                    self.restaurants = self.$store.getters.config.restaurants;
                }
            });
            this.$store.watch( (state)=> {return this.$store.getters.config; }, (val) => {
                self.restaurants = self.$store.getters.config.restaurants;
            });
        },
        mounted : function()
        {
            let self = this;
            if( !isNull(this.$store.getters.config) )
            {
                self.restaurants = self.$store.getters.config.restaurants;
            }
        }
    }
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0
    }
</style>


// WEBPACK FOOTER //
// RestaurantList.vue?f15111d6